import * as React from 'react';
import ProjectsInfoModal from '../ProjectsInfoModal';
import useProfileUsageMetrics from '../../hooks/useProfileUsageMetrics';

function InsightsCreditPackageUsage() {
  const { data, error, loading } = useProfileUsageMetrics();
  const packages = data?.insight_credit_packages_usage_meter?.packages;

  if (loading || !packages || packages.length === 0) {
    return null;
  }

  if (error) {
    return (
      <div className="py-4 border-bottom">
        <p className="clearfix">
          <div className="card">
            <div className="card-body">
              <h4 className="card-title"><strong>Insight Credit Packages</strong></h4>
              <div>Unable to load package usage.</div>
            </div>
          </div>
        </p>
      </div>
    );
  }

  function insights_percentage(used: number, max: number) {
    return Math.round((used / max) * 100);
  }

  return (
    <div className="py-4 border-bottom">
      <p className="clearfix">
        <div className="card">
          <div className="card-body">
            <h4 className="card-title"><strong>Insight Credit Packages</strong></h4>
            <p className="page-description">Additional AI insight credits purchased.</p>
            <div className="template-demo">
              {packages.map((pkg, index) => (
                <span key={index}>
                  <div className="d-flex justify-content-between mt-2">
                    <small>Credit Package #{index + 1}</small>
                    <small>{pkg.used + '/' + pkg.max}</small>
                  </div>
                  <div className="progress progress-lg mt-2">
                    <div
                      className="progress-bar bg-danger"
                      role="progressbar"
                      style={{ width: `${insights_percentage(pkg.used, pkg.max)}%` }}
                    >
                      {insights_percentage(pkg.used, pkg.max)}%
                    </div>
                  </div>
                </span>
              ))}
            </div>
            <div className='mt-2'>
              <p className="card-description">
                <small>
                  Need more insights? Purchase additional credit packages <a href="/shop/insight_credit_packages">here</a>.
                </small>
              </p>
            </div>
          </div>
        </div>
      </p>
    </div>
  );
}

export default InsightsCreditPackageUsage;
